import { Component, OnInit, Inject, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { timeStamp } from 'console';
import { environment } from '../../../../environments/environment';
import { AttachFilesService } from '../../../services/attach-files.service';

@Component({
  selector: 'app-picture-gallery',
  templateUrl: './picture-gallery.component.html'
})
export class PictureGalleryComponent implements OnInit {

  path: any
  urlImg: string;
  files: any;
  imageSrc: string;
  datas: any[];
  images: any[];
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  constructor(
    private attachFiles: AttachFilesService,
    public dialogRef: MatDialogRef<PictureGalleryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.getAttachFile()

    // this.images = [
    //   {
    //     "previewImageSrc": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Chanyeol_during_the_Exo_Planet_5_%E2%80%93_Exploration_concert_on_December_2019.jpg/220px-Chanyeol_during_the_Exo_Planet_5_%E2%80%93_Exploration_concert_on_December_2019.jpg",
    //     "thumbnailImageSrc": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Chanyeol_during_the_Exo_Planet_5_%E2%80%93_Exploration_concert_on_December_2019.jpg/220px-Chanyeol_during_the_Exo_Planet_5_%E2%80%93_Exploration_concert_on_December_2019.jpg",
    //     "alt": "Description for Image 1",
    //     "title": "Title 1"
    //   },
    //   {
    //     "previewImageSrc": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Chanyeol_during_the_Exo_Planet_5_%E2%80%93_Exploration_concert_on_December_2019.jpg/220px-Chanyeol_during_the_Exo_Planet_5_%E2%80%93_Exploration_concert_on_December_2019.jpg",
    //     "thumbnailImageSrc": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Chanyeol_during_the_Exo_Planet_5_%E2%80%93_Exploration_concert_on_December_2019.jpg/220px-Chanyeol_during_the_Exo_Planet_5_%E2%80%93_Exploration_concert_on_December_2019.jpg",
    //     "alt": "Description for Image 2",
    //     "title": "Title 2"
    //   },
    // ]
  }
  getAttachFile() {
    this.images = []
    this.attachFiles.getAttachFilesDetail({
      tableName: this.data.tableName,
      id_data: this.data.id_data
    }, this.data.permission).subscribe(res => {
      res.data.forEach(element => {
        var fileNameArr = element.filename.split('.') || [];
        var fm = fileNameArr[fileNameArr.length - 1];
        if (fm.toLowerCase() == 'jpg' || fm.toLowerCase() == 'jpeg' || fm.toLowerCase() == 'png') {
          console.log(element);

          this.images.push({
            previewImageSrc: environment.apiUrl + 'files/' + element.tableName + '/' + element.id_data + '/' + element.filename,
            // previewImageSrc: environment.apiUrl + `files/${element.path}`,
            // thumbnailImageSrc: environment.apiUrl + `files/${element.path}`,
            "alt": "Description for Image 2",
            "title": "Title 2"
          })
        }
      });
      console.log(this.images);
    });

  }
  onNoClick() {
    this.dialogRef.close()
  }
}